import { put, take, race } from "@redux-saga/core/effects";
import { handleError } from "../../../util/errorHandler";
import {
  MODAL_CANCEL,
  MODAL_CONFIRM,
  setConfirmModalType,
} from "../../reducers/modalReducer";

export default function* confirmSaga(modalType: any) {
  try {
    yield put(setConfirmModalType(modalType));
    const { yes } = yield race({
      yes: take(MODAL_CONFIRM),
      no: take(MODAL_CANCEL),
    });
    yield put(setConfirmModalType(null));
    return Boolean(yes);
  } catch (error) {
   yield handleError(error);
  }
}
